export const dateConverter = (startDate: Date, endDate: Date) => {
  const sd = new Date(startDate).toString().split(" ");
  const ed = new Date(endDate).toString().split(" ");
  return `${sd[1]} ${sd[2]} - ${ed[1]} ${ed[2]}, ${ed[3]}`;
};

export const dateFormatter = (dateTime: string) => {
  let date = new Date(dateTime);
  let formattedDate = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return formattedDate;
};

export const sortProperties = (obj: object) => {
  const sortedObj = {};
  Object.keys(obj)
    .sort()
    .forEach((key) => {
      sortedObj[key] = obj[key];
    });
  return sortedObj;
};

export const compareTwoObjAreDifferent = (obj1: object, obj2: object) => {
  return (
    JSON.stringify(sortProperties(obj1 || {})) !==
    JSON.stringify(sortProperties(obj2 || {}))
  );
};

export const formatDateForFilters = (date) => {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [day, month, year].join("/");
};

export const formatDateForRequest = (date) => {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return `${[year, month, day].join("-")}T00:00:00`;
};

export const formatDate = (date) => {
  let d = new Date(date);
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
};

// ====================
export const startDownloadingFile = (response: any, fileName: string) => {
  let dataToDownload;
  let contentType;

  const fileExtension = fileName.split(".").pop()?.toLowerCase();

  switch (fileExtension) {
    case "json":
      contentType = "application/json";
      dataToDownload = JSON.stringify(response, null, 2);
      break;
    case "txt":
      contentType = "text/plain";
      dataToDownload = response;
      break;
    case "csv":
      contentType = "text/csv";
      dataToDownload = response;
      break;
    case "html":
      contentType = "text/html";
      dataToDownload = response;
      break;
    case "xml":
      contentType = "application/xml";
      dataToDownload = response;
      break;
    case "pdf":
      contentType = "application/pdf";
      dataToDownload = response;
      break;
    default:
      contentType = "application/octet-stream";
      dataToDownload = response;
      break;
  }

  const blob = new Blob([dataToDownload], { type: contentType });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
};
